<template>
  <div v-if="bits">
    <b-row>
      <b-col cols="2" />
      <b-col cols="5"><h3>Picture</h3></b-col>
      <b-col cols="5"><h3>Video</h3></b-col>
    </b-row>
    <b-row v-for="(e, ei) in 6">
      <b-col cols="2">
        <h3>{{ events[ei] }}</h3>
      </b-col>
      <b-col v-for="(c, ci) in 10" cols="1">
        <base-input :label="cameras[ci]">
          <b-form-checkbox class="mb-3" :key="(ei * 10) + ci" v-model="bits[(ei * 10) + ci]" @input="onBitChanged(ei, ci)" />
        </base-input>
      </b-col>
    </b-row>
    <div style="display: none;">
      Calculate camera event mask => {{ eventMask }}
    </div>
  </div>
</template>

<script>
export default {
  name: "calculate-camera-event-mask",
  props: {
    eventMask: {
      type: Object,
      required: true,
      description: "Event mask"
    }
  },
  mounted() {
    this.setBits()
  },
  watch: {
    eventMask: {
      handler(value) {
        this.setBits()
      },
      deep: true
    },
  },
  data: _ => ({
    cameras: [ 'Front', 'Rear', 'Left', 'Right', 'Driver', 'Front', 'Rear', 'Left', 'Right', 'Driver' ],
    cameraBits: [ 1, 2, 4, 8, 16, 32, 64, 128, 256, 512 ],
    events: [ 'Emergency brake', 'Harsh brake', 'Harsh acceleration', 'Over speed start', 'Over RPM start', 'Idle start'],
    bits: undefined
  }),
  methods: {
    setBits() {
      if (!this.bits) {
        this.bits = []
      }

      for (let e = 0; e < 6 ; e++) {
        for (let c = 0 ; c < 10 ; c++) {
          this.bits[(e * 10) + c] = this.getEnabled(e, c)
        }
      }
    },
    getEnabled(row, camera) {
      let mask = this.getEventCameraMask(row)

      // console.log('event mask [' + this.events[row] + '] = ' + mask)

      return (mask & BigInt(this.cameraBits[camera])) === BigInt(this.cameraBits[camera])
    },
    getEventCameraMask(eventIndex) {
      return BigInt(1023n & (BigInt(this.eventMask.value) >> (BigInt(eventIndex) * 10n)))
    },
    onBitChanged(row, camera) {
      // console.log('bit changed for row : ' + row + ' and camera : ' + camera + ' => ' + this.bits[(row * 10) + camera])

      let strMask = '0000'

      for (let i = 59 ; i >= 0 ; i--) {
        strMask += this.bits[i]? '1' : '0'
      }

      // console.log('new string mask = ' + strMask + ' ; bigint mask => ' + parseInt(strMask, 2))

      this.eventMask.value = parseInt(strMask, 2).toString()
    },
  }
}
</script>

<style scoped>

</style>
